import { render, staticRenderFns } from "./luckyBag.vue?vue&type=template&id=7dd3ec2a"
import script from "./luckyBag.vue?vue&type=script&lang=js"
export * from "./luckyBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports